import { IconNameType, SuggestionActionObjectEnum, SuggestionsPriorityEnum } from '@/types'

import { PATIENTS_SUGGESTIONS_PATH, PJ_SUGGESTIONS_PATH } from './navigation'

export const SUGGESTION_PATHS: Record<SuggestionActionObjectEnum, string> = {
  [SuggestionActionObjectEnum.PATIENT_JOURNEYS]: PJ_SUGGESTIONS_PATH,
  [SuggestionActionObjectEnum.CLIENTS]: PATIENTS_SUGGESTIONS_PATH,
}

export const SUGGESTION_PRIORITY_ICONS: Record<SuggestionsPriorityEnum, IconNameType> = {
  [SuggestionsPriorityEnum.LOW]: 'ChevronDoubleDownIcon',
  [SuggestionsPriorityEnum.MEDIUM]: 'EqualsIcon',
  [SuggestionsPriorityEnum.HIGH]: 'ChevronDoubleUpIcon',
}

export const SUGGESTION_PRIORITY_COLORS: Record<SuggestionsPriorityEnum, string> = {
  [SuggestionsPriorityEnum.LOW]: 'text-indigo-500',
  [SuggestionsPriorityEnum.MEDIUM]: 'text-orange-500',
  [SuggestionsPriorityEnum.HIGH]: 'text-red-500',
}
